import {InjectionToken, NgModule} from "@angular/core";
import {IntPortalOutletComponent} from "./int-portal-outlet.component";
import {CommonModule} from "@angular/common";
import {IntPortalOutletService} from "./int-portal-outlet.service";
import {IntPortalTemplateWrapComponent} from "./int-portal-template-wrap.component";

//export const INT_PORTAL_OUTLET_TOKEN = new InjectionToken('int portal outlet token');

@NgModule({
  imports: [CommonModule],
  declarations: [
    IntPortalOutletComponent,
    IntPortalTemplateWrapComponent
  ],
  exports: [
    IntPortalOutletComponent,
    IntPortalTemplateWrapComponent
  ],
  providers: [
    IntPortalOutletService
  ]
})
export class IntPortalOutletModule {

}
